<div class="container-fluid">
  <nz-card>
    <div class="row mt-3">
      <div class="col-md-12">
        <app-data-grid
          id="gridContainer"
          style="width: 100%"
          [dataSource]="gridData"
          [searchPanel]="true"
          [filterRow]="true"
          [filterPanel]="true"
          [groupPanel]="true"
          [columnChooser]="true"
          [allowExport]="USER_PERMISSIONS.exprt_in == 1 ? true : false"
          exportFileName="States Details"
          [pageSize]="10"
          [allowedPageSizes]="[10, 25, 50, 100]"
          [showPageSizeSelector]="true"
          [rowAlternationEnabled]="true"
          [showBorders]="true"
        >
          <app-grid-column
            caption="S.No"
            cellTemplate="serialNumberTemplate"
            [width]="70"
          ></app-grid-column>

          <app-grid-column
            dataField="ste_nm"
            caption="State Name"
          ></app-grid-column>

          <app-grid-column
            caption="Actions"
            cellTemplate="actionTemplate"
            [width]="100"
          ></app-grid-column>
          <ng-template appGridCell="actionTemplate" let-data="cell"
            ><div>
              <button
                nz-button
                nzType="primary"
                nzShape="circle"
                (click)="editRecord(data.data)"
              >
                <i nz-icon nzType="edit"></i>
              </button>
              <button
                nz-button
                nzType="danger"
                nzShape="circle"
                class="ml-2"
                (click)="deleteRecord(data.data)"
              >
                <i nz-icon nzType="delete"></i>
              </button></div
          ></ng-template>
          <ng-template appGridCell="serialNumberTemplate" let-data="cell"
            ><div>
              {{ data.rowIndex + 1 }}
            </div></ng-template
          >
        </app-data-grid>
      </div>
    </div>
  </nz-card>
</div>

<nz-drawer
  [nzVisible]="shwSidebar"
  [nzTitle]="sidebarHeading"
  (nzOnClose)="closeSidebar()"
  [nzWidth]="500"
>
  <ng-container *nzDrawerContent>
    @if (shwDeleteCnfrm == false) {
    <div>
      <form nz-form [formGroup]="stateForm" (ngSubmit)="submitForm()">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>State Name</nz-form-label>
          <nz-form-control [nzSpan]="24" nzErrorTip="Please enter state name">
            <input
              nz-input
              formControlName="ste_nm"
              placeholder="Enter state name"
            />
          </nz-form-control>
        </nz-form-item>
        <div class="text-right">
          <button
            nz-button
            nzType="default"
            class="mr-2"
            (click)="closeSidebar()"
          >
            Cancel
          </button>
          <button nz-button nzType="primary" [nzLoading]="shwLdng">
            {{ editdata ? "Update" : "Save" }}
          </button>
        </div>
      </form>
    </div>
    } @if (shwDeleteCnfrm == true) {
    <div>
      <h3>Are you sure want to delete this record?</h3>
      <div class="text-right mt-2">
        <button
          nz-button
          nzType="default"
          class="mr-2"
          (click)="cancelDelete()"
        >
          No
        </button>
        <button
          nz-button
          nzType="primary"
          [nzLoading]="shwLdng"
          (click)="confirmDelete()"
        >
          Yes
        </button>
      </div>
    </div>
    }
  </ng-container>
</nz-drawer>
